/* eslint-disable */
export default function isObjectEmpty(obj: Record<string, unknown>): boolean {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return true;
}
